import { render, staticRenderFns } from "./UserAdditionalDataEdition.vue?vue&type=template&id=c826b190&"
import script from "./UserAdditionalDataEdition.vue?vue&type=script&lang=js&"
export * from "./UserAdditionalDataEdition.vue?vue&type=script&lang=js&"
import style0 from "./UserAdditionalDataEdition.vue?vue&type=style&index=0&id=c826b190&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports